import { createMemoryHistory, createBrowserHistory, Action } from 'history';

import gtmHelpers from '^utils/gtmHelpers';

const sharedHistory = window.xprops.isWidgetMode ? createMemoryHistory() : createBrowserHistory();

sharedHistory.listen(({ location, action }): void => {
  gtmHelpers.emitPageView(location.pathname);

  if (action !== Action.Replace) {
    void window.xprops.scrollToWidget();
  }
});

export default sharedHistory;
